import ActivityLog from './ActivityLog';
import CardLinkSettings from './CardLinkSettings';

interface MorePanelProps {
  logs: Array<{ id: number | string; text: string; color: string }>;
  statsLine: string;
  hasOnChainShop: boolean;
  onChangeShop: () => void;
  onNavigate: (path: string) => void;
  onLogout: () => void;
}

const GHOST_PILL =
  'w-full pixel-corners-sm bg-white border-2 border-hairline text-body-grey font-grotesk font-bold text-[13px] py-3 px-4 text-center transition-colors hover:border-coral hover:text-coral';

// Content of the MORE tab — profile home: change shop, owner entry, activity
// and card-link settings, log out. Router-free by design — onNavigate is a
// caller-supplied wrapper around react-router's navigate, so this component
// can be tested without a Router. Sits directly below <PlayerName/> (the
// PLAYER card) in Dashboard's moreContent — that composition, not this
// component, owns the name/birthday editor AND the wallet-address display
// (review ruling, Task 10 fix pass: the address must show exactly once on
// the composed MORE screen; MorePanel used to render its own copy below,
// duplicating PlayerName's).
export default function MorePanel({
  logs,
  statsLine,
  hasOnChainShop,
  onChangeShop,
  onNavigate,
  onLogout,
}: MorePanelProps) {
  return (
    <>
      <p className="font-heading text-[9px] text-body-grey text-center">{statsLine}</p>

      <div className="bg-white pixel-corners p-[18px] flex flex-col gap-2.5">
        <button onClick={onChangeShop} className={GHOST_PILL}>
          Change shop
        </button>

        {hasOnChainShop ? (
          <button onClick={() => onNavigate('/shops/owner/dashboard')} className={GHOST_PILL}>
            Your guild — manage shop
          </button>
        ) : (
          <button
            onClick={() => {
              const seen = localStorage.getItem('bitbrew_seen_for_shops');
              onNavigate(seen ? '/shops/register' : '/for-shops');
            }}
            className={GHOST_PILL}
          >
            Own a cafe? Join the Brew Guild
          </button>
        )}
      </div>

      <div className="bg-white pixel-corners p-[18px]">
        <ActivityLog logs={logs} />
      </div>

      <div className="bg-white pixel-corners p-[18px]">
        <CardLinkSettings />
      </div>

      <button
        onClick={onLogout}
        className="w-full pixel-corners-sm border-2 border-error text-error bg-transparent font-grotesk font-bold text-[13px] py-3 px-4"
      >
        Log out
      </button>

      {/* Legal links live here since GameLayout lost its footer (app frame) */}
      <div className="flex items-center justify-center gap-3 pt-1 pb-2">
        <a href="/privacy" className="font-grotesk font-medium text-[12px] text-body-grey">
          Privacy Policy
        </a>
        <span className="text-hairline">│</span>
        <a href="/terms" className="font-grotesk font-medium text-[12px] text-body-grey">
          Terms of Service
        </a>
      </div>
    </>
  );
}
